/* ==========================================================================
   Feel · Blog Listing — Filter chips + Live search + Sticky filter top
   Source: _mockups/01_ALL_HTML_MOCKUPS/blog.html
   Loaded by: sections/feel-blog.liquid
   ========================================================================== */

(function () {
  'use strict';

  /* ===== STICKY FILTER BAR — pin below real header height ===== */
  var filterBar = document.querySelector('[data-blog-filters]');
  if (filterBar) {
    function setFilterTop() {
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        filterBar.style.top = headerGroup.offsetHeight + 'px';
      }
    }
    setFilterTop();
    window.addEventListener('resize', setFilterTop);
  }

  /* ===== CLIENT-SIDE CATEGORY FILTER ===== */
  var chips  = document.querySelectorAll('[data-blog-chip]');
  var cards  = document.querySelectorAll('[data-blog-card]');
  var noResults = document.querySelector('[data-blog-no-results]');

  function filterCards(category) {
    var visibleCount = 0;
    cards.forEach(function (card) {
      // Opcija B: data-blog-card is space-separated filter_key tags — use indexOf for contains match
      var cardCats = card.dataset.blogCard ? card.dataset.blogCard.split(' ') : [];
      var show = (category === 'all' || cardCats.indexOf(category) !== -1);
      card.dataset.hidden = show ? 'false' : 'true';
      if (show) visibleCount++;
    });
    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var target = chip.dataset.blogChip;
      // Update active state
      chips.forEach(function (c) {
        c.setAttribute('aria-selected', String(c.dataset.blogChip === target));
        c.classList.toggle('chip-active', c.dataset.blogChip === target);
      });
      filterCards(target);
      // Also clear search if active
      var searchInput = document.querySelector('[data-blog-search-input]');
      if (searchInput && searchInput.value.trim()) {
        searchInput.value = '';
        filterCards(target);
      }
    });
  });

  /* ===== LIVE SEARCH ===== */
  var searchInput  = document.querySelector('[data-blog-search-input]');
  var searchStatus = document.querySelector('[data-blog-search-status]');

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();

      if (!query) {
        // Restore current chip filter
        var activeChip = document.querySelector('[data-blog-chip][aria-selected="true"]');
        var activeCat = activeChip ? activeChip.dataset.blogChip : 'all';
        filterCards(activeCat);
        if (searchStatus) { searchStatus.hidden = true; searchStatus.textContent = ''; }
        return;
      }

      // Reset chip selection to "all" when searching
      chips.forEach(function (c) {
        c.setAttribute('aria-selected', String(c.dataset.blogChip === 'all'));
        c.classList.toggle('chip-active', c.dataset.blogChip === 'all');
      });

      var matchCount = 0;
      cards.forEach(function (card) {
        var text = (card.textContent || '').toLowerCase();
        var matches = text.indexOf(query) !== -1;
        card.dataset.hidden = matches ? 'false' : 'true';
        if (matches) matchCount++;
      });

      if (searchStatus) {
        searchStatus.hidden = false;
        // Instant filter only covers the CURRENT page — Enter submits the form to
        // /search?type=article for a full-text search across all articles.
        searchStatus.textContent = matchCount === 0
          ? 'Nothing on this page — press Enter to search all articles.'
          : matchCount + ' on this page · press Enter to search all articles';
      }
      if (noResults) { noResults.hidden = matchCount > 0; }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
        searchInput.blur();
      }
    });
  }

})();
